angular.module("annexes")

    .controller("AnnexesEditCtrl", ['$rootScope', '$scope', '$http', '$stateParams', 'Restangular', '$state', 'modalService', '$filter', function ($rootScope, $scope, $http, $stateParams, Restangular, $state, modalService, $filter) {

        $scope.annexes = {};
        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

            $rootScope.breadcrumb = [
                { title: $filter('translate')('annexes.subtitleList'), url: "annexes.list" },
                { title: $filter('translate')('general.add') }
            ];
        }
        else {
            Restangular.one('AnnexesTypes', $stateParams.id).get().then(function (results) {
                $scope.annexes = results;
                let pp = $scope.annexes.FK_events_programs_annexes_types_tl_events_programs_annexes_types.filter(name => name['language_id'] == 1);

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('annexes.subtitleList'), url: "annexes.list" },
                    { title: $scope.annexes.FK_events_programs_annexes_types_tl_events_programs_annexes_types.filter( name => name['language_id'] == 1).name + " - " + $filter('translate')('general.edit') }
                ];


            }, function (response) {
                $scope.errorMessage = response.message;
            });
        }

        $scope.cancel = function () {
            $state.go("annexes.list", { "reset": false });
        };


        $scope.save = function () {
            if (angular.isUndefined($stateParams.id) || $stateParams.id === "")
                Restangular.all('AnnexesTypes').post($scope.annexes).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('documents_types.create_success'));
                        $scope.annexes.id = result.id;
                        $state.go("annexes.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            else {
                $scope.annexes.put().then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('documents_types.edit_success'));
                        $state.go("annexes.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        };

        $scope.delete = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('general.delete'),
                message: $filter('translate')('general.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('AnnexesTypes', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('documents_types.delete_success'));
                        $state.go("annexes.list", { "reset": false });
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

    }])

    ;